import { useEffect, useState } from 'react';

import type { IVDLButton } from '@VDL/api/types/IVDLButton';
import { getVDLButtons } from '@VDL/api';
import { isAxiosError } from 'axios';

export const useFetchButtons = (level0Code?: string | undefined) => {
  const [buttons, setButtons] = useState<IVDLButton[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  const fetchButtons = async (level0Code?: string | undefined) => {
    setLoading(true);
    setError(null);
    setButtons([]);

    try {
      const response = await getVDLButtons(level0Code);

      setButtons(response.data);
    } catch (error) {
      if (isAxiosError(error)) setError(error.message);
      else setError('Неизвестная ошибка');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchButtons(level0Code);
  }, [level0Code]);

  return { buttons, error, loading, fetchButtons };
};
